import { defineField, defineType } from 'sanity'
import { internalPages } from '../../structure/deskStructure'

export default defineType({
  title: 'Special event promotions block',
  name: 'specialEventPromotions',
  type: 'object',
  fields: [
    defineField({
      title: 'Title',
      name: 'title',
      type: 'string',
      description:
        'Not used on the page, only acts as label for the editor in Sanity Studio.',
    }),
    defineField({
      title: 'Promotions',
      name: 'promotions',
      type: 'array',
      of: [
        {
          type: 'object',
          name: 'promotionItem',
          fields: [
            defineField({
              title: 'Title',
              name: 'title',
              type: 'string',
            }),
            defineField({
              title: 'Subtitle',
              name: 'subtitle',
              type: 'string',
            }),
            defineField({
              title: 'Label',
              name: 'label',
              type: 'string',
            }),
            defineField({
              title: 'Note',
              name: 'note',
              type: 'string',
            }),
            defineField({
              title: 'URL (i)',
              name: 'url',
              description: 'Search for internal page.',
              type: 'reference',
              to: internalPages.map((page) => ({ type: page })),
              options: {
                disableNew: true,
              },
            }),
            defineField({
              name: 'photo',
              title: 'Photo',
              type: 'image',
              options: {
                hotspot: true,
              },
            }),
          ],
        },
      ],
      validation: (rule) => [rule.min(2), rule.max(4)],
    }),
  ],
  preview: {
    select: {
      title: 'title',
    },
    prepare({ title }) {
      return {
        title: title || 'Special Event Promotions',
        subtitle: 'Special Event Promotions',
      }
    },
  },
})
